import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import api from "../../../api/api";
import { fetchNotice } from "../../../features/noticeSlice/NoticeSlice";
import Images from "../../../media/images";
import UpdateNotice from "./UpdateNotice";

const NoticeList = () => {
  // const notice = useSelector((state) => state.notice.data);
  // console.log("check", notice);
  const [changes, setChanges] = useState(true);
  const [notices, setNotices] = useState([]);
  const [noticeItem, setNoticeItem] = useState({});
  const [viewMore, setViewMore] = useState(true)


  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(fetchNotice());
    api
      .get("/notices/")
      .then((response) => {
        setNotices(response.data);
      })
      .catch((error) => {});
  }, [changes]);

  const handleDelete = (id) => {
    api
      .delete(`/notices/${id}/`)
      .then((response) => {
        toast.success("Data Deleted Successfully");
        setChanges(!changes);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleSearch = (e) => {
    api
      .get(`/notices/?search=${e.target.value}`)
      .then((response) => {
        // console.log(response.data);
        setNotices(response.data);
      })
      .catch((error) => {});
  };


  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Notice List
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <div className="flex items-center justify-start gap-10">
                  <input
                    type="text"
                    placeholder="Search by date "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by name "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />

                  <input
                    type="text"
                    placeholder="Search by staff "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <table className="min-w-full text-center">
                  <thead className="font-Bree bg-primary-red border-b font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Notice No.
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Notice Heading
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Posted Staff Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                      {/* <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th> */}
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {notices.slice(0, `${viewMore ? 10 : notices.length}`).map((item, i) => {
                      return (
                        <tr className="border-b bg-white">
                          <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            {i + 1}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            {item.id}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            {item.title}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            {item.author_name}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            {/* <div onClick={() => setNoticeItem(item)}> */}
                              <button
                                data-bs-toggle="modal"
                                data-bs-target="#NoticeListDemo"
      
                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                                onClick={() => setNoticeItem(item)}
                              >
                                View/Edit
                              </button>
                            {/* </div> */}

                           
                              <UpdateNotice noticeItem={noticeItem}  setChanges={setChanges} changes={changes}/>
                          
                            <button
                              className="bg-primary-red rounded-full p-1 px-2 ml-1 text-white"
                              onClick={() => handleDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>

                          {/* <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                            <a
                              href=""
                              className="bg-primary-blue rounded-full p-1 px-2 text-white"
                            >
                              Show
                            </a>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <a href="">Print</a>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  {/* <a href="">View More</a> */}
                  {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default NoticeList;
